import React, { Fragment, useEffect, useState } from 'react';
import { Row, Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  API_Ingetration,
  gAPI_Internal_Property_By_Id,
  gAPI_Property_List_By_Group,
  postAPI_GM_CommunicationChannel,
  getAPI_GM_CommunicationChannel_All,
  getAPI_GM_CommunicationChannel_ByGroupPropertyType,
  deleteAPI_GM_CommunicationChannel_ByGroupPropertyType,
  API_SMS_INTEGRATION,
} from '../../../../../../constants/APIs';

import SMSIntegration from '../../../integration/components/SMS/SmsIntegrations';
import SMSIntegrationThumb from './components/SmsIntegrationThumb';
import WhatsappIntegration from '../../../integration/components/WhatsApp/WhatsappIntegration';
import WhatsappIntegrationThumb from './components/WhatsappIntegrationThumb';
import AddEmailIntegration from '../../../integration/components/Email/AddEmailIntegration';
import EmailIntegrationThumb from './components/EmailIntegrationThumb';

import EmailLogo from '../../../../../../assets/email_icon.png';
import WhatsApp_Logo from '../../../../../../assets/whatsapp_icon.svg';
import SMS_Logo from '../../../../../../assets/sms.svg';

const CommunicationChannels = ({ propertyId, userName }) => {
  const [allProperties, setAllProperties] = useState([]);
  const [selectedWhatsAppIntegrationId, setSelectedWhatsAppIntegrationId] = useState(null);
  const [selectedWhatsAppChannelName, setSelectedWhatsAppChannelName] = useState(null);

  const [selectedSMSChannelName, setSelectedSMSChannelName] = useState(null);
  const [selectedSMSIntegrationId, setSelectedSMSIntegrationId] = useState(null);
  const [selectedEmailIntegrationId, setSelectedEmailIntegrationId] = useState(null);
  const [selectedEmailChannelName, setSelectedEmailChannelName] = useState(null);

  const [whatsAppIntegrations, setWhatsAppIntegrations] = useState([]);
  const [SMSIntegrations, setSMSIntegrations] = useState([]);
  const [unifiedEmailIntegrationsList, setUnifiedEmailIntegrationsList] = useState([]);

  const [isAddWhatsApp, setIsAddWhatsApp] = useState(false);
  const [isAddSMS, setIsAddSMS] = useState(false);
  const [isUnifiedEmailIntegration, setIsUnifiedEmailIntegration] = useState(false);

  const [isEmail, setIsEmail] = useState(false);
  const [isSocial, setIsSocial] = useState(false);
  const [isGuestMessaging, setIsGuestMessaging] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const LoadIntegrations = () => {
    setIsLoading(true);
    const body = {
      channels: ['WhatsApp', 'EmailAssistant', 'Sms'],
    };

    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body,
    })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        const whatsApp = data.filter(
          (k) =>
            String(k.channel).toLowerCase() === 'whatsapp' &&
            Array.isArray(k.properties) &&
            k.properties.includes(propertyId)
        );
        const emailUnified = data.filter(
          (k) =>
            String(k.channel).toLowerCase() === 'emailassistant' &&
            Array.isArray(k.properties) &&
            k.properties.includes(propertyId)
        );
        const SMS = data.filter(
          (k) =>
            String(k.channel).toLowerCase() === 'sms' &&
            Array.isArray(k.properties) &&
            k.properties.includes(propertyId)
        );

        setWhatsAppIntegrations(whatsApp);
        setUnifiedEmailIntegrationsList(emailUnified);
        setSMSIntegrations(SMS)
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Error loading integrations for Guest Messaging Channels:', err);
      })
      .finally(() => setIsLoading(false));
  };


  useEffect(() => {
    if (!propertyId) return;

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        const data = res.data || {};
        setIsGuestMessaging(Boolean(data.isGuestMessaging))
        setIsSocial(Boolean(data.isSocialChannel));
        setIsEmail(Boolean(data.isEmailAutomation));
      })
      // eslint-disable-next-line no-console
      .catch((err) => console.error('Error fetching property capabilities:', err));
  }, [propertyId]);


  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    })
      .then((res) => setAllProperties(res.data || []))
      // eslint-disable-next-line no-console
      .catch((err) => console.error('Error loading properties list:', err));
  }, []);

  // const fetchChannelSelection = async (channelType) => {
  //   const groupId = getGroupID();

  //   try {
  //     const res = await AxiosAPI({
  //       method: 'get',
  //       url: `${getAPI_GM_CommunicationChannel_ByGroupPropertyType}?groupId=${groupId}&propertyId=${propertyId}&channelType=${channelType}`,
  //     });

  //     return res.data?.integrationId || null;
  //   } catch {
  //     return null;
  //   }
  // };

  const loadSelectedChannels = async () => {
    if (!propertyId) return;

    try {
      const res = await AxiosAPI({
        method: 'get',
        url: `${getAPI_GM_CommunicationChannel_All}`,
      });

      const all = res.data || [];
      const propertyChannels = all.filter((item) => item.propertyId === propertyId);

      const wa = propertyChannels.find(
        (i) => String(i.channel || '').toLowerCase().includes('what')
      );
      const email = propertyChannels.find(
        (i) => String(i.channel || '').toLowerCase().includes('email')
      );
      const sms = propertyChannels.find(
        (i) => String(i.channel || '').toLowerCase().includes('sms')
      );

      setSelectedWhatsAppIntegrationId(wa?.integrationId || null);
      setSelectedWhatsAppChannelName(wa?.channel || null);

      setSelectedEmailIntegrationId(email?.integrationId || null);
      setSelectedEmailChannelName(email?.channel || null);

      setSelectedSMSIntegrationId(sms?.integrationId || null)
      setSelectedSMSChannelName(sms?.channel || null)



    } catch (e) {
      console.error('Failed to load communication channels', e);
    }
  };

  // Initial integrations load, and refresh when a modal closes
  useEffect(() => {
    LoadIntegrations();
    loadSelectedChannels();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyId]);

  const handleSelectIntegration = async (channelType, integrationId) => {
    if (!integrationId) return;
    const groupId = getGroupID();

    // don't re-create if already selected
    const currentSelected =
      channelType === 'WhatsApp' ? selectedWhatsAppIntegrationId : (channelType === "Sms" ? selectedSMSIntegrationId : selectedEmailIntegrationId);
    if (currentSelected === integrationId) return;

    try {
      await AxiosAPI({
        method: 'post',
        url: postAPI_GM_CommunicationChannel,
        data: {
          propertyId,
          groupId,
          integrationId,
          channel: channelType,
          createdBy: userName,
          updatedBy: userName,
        },
      });
      await loadSelectedChannels();
    } catch (e) {
      console.error('Failed to create communication channel', e);
    }
  };

  const handleDeleteSelectedIntegration = async (channelType) => {
    const groupId = getGroupID();

    const actualChannel =
      channelType === 'WhatsApp' ? selectedWhatsAppChannelName : (channelType === "Sms" ? selectedSMSChannelName : selectedEmailChannelName);

    const currentSelected =
      channelType === 'WhatsApp' ? selectedWhatsAppIntegrationId : (channelType === "Sms" ? selectedSMSIntegrationId : selectedEmailIntegrationId);

    if (!currentSelected || !actualChannel) {

      return;
    }

    try {
      await AxiosAPI({
        method: 'delete',
        url: `${deleteAPI_GM_CommunicationChannel_ByGroupPropertyType}?groupId=${groupId}&propertyId=${propertyId}&channelType=${actualChannel}`,
      });

      // refresh everything after delete
      await loadSelectedChannels();
    } catch (e) {
      console.error('Failed to delete selected communication channel', e);
    }
  };

  const hasAnyIntegration =
    whatsAppIntegrations.length > 0 || unifiedEmailIntegrationsList.length > 0 || SMSIntegrations.length > 0;


  const renderConnectCards = () => (
    <Row className="m-2 my-3">

      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
        <Card className="d-flex flex-row integrationcard" style={{ height: '215px' }}>
          <CardBody className="mt-0">
            <div className="connect-title">
              <div className="integrationChannel mt-2">
                <img src={WhatsApp_Logo} alt="WhatsApp" style={{ width: '3rem' }} />
              </div>
              {!isSocial ? (
                <Button size="xs" color="outline-grey">
                  <span>Not Available</span>
                </Button>
              ) : (
                <Button size="xs" color="primary" outline onClick={() => setIsAddWhatsApp(true)}>
                  <IntlMessages id="dashboards.connect" />
                </Button>
              )}
            </div>

            <Row>
              <Colxx xxs="12" className="mb-5" style={{ marginTop: '2rem' }}>
                <div className="text-left">
                  <h2>WhatsApp</h2>
                  <span>
                    Automate responses to WhatsApp messages. Manage and reply to
                    conversations from a unified inbox.
                  </span>
                </div>
              </Colxx>
            </Row>
          </CardBody>
        </Card>
      </Colxx>

      {/* Emails in Unified Inbox */}
      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
        <Card className="d-flex flex-row integrationcard" style={{ height: '215px' }}>
          <CardBody className="mt-0">
            <div className="connect-title">
              <div className="integrationChannel mt-2">
                <img src={EmailLogo} alt="Emails in Unified Inbox" style={{ width: '2.5rem' }} />
              </div>
              {!isEmail ? (
                <Button size="xs" color="outline-grey">
                  <span>Not Available</span>
                </Button>
              ) : (
                <Button size="xs" color="primary" outline onClick={() => setIsUnifiedEmailIntegration(true)}>
                  <IntlMessages id="dashboards.connect" />
                </Button>
              )}
            </div>

            <Row>
              <Colxx xxs="12" className="mb-5" style={{ marginTop: '2rem' }}>
                <div className="text-left">
                  <h2>Emails in Unified Inbox</h2>
                  <span>
                    Receive all your emails in the Unified Inbox — reply manually
                    or let AI handle it for you.
                  </span>
                </div>
              </Colxx>
            </Row>
          </CardBody>
        </Card>
      </Colxx>

      {/* sms */}
      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
        <Card className="d-flex flex-row integrationcard" style={{ height: '215px' }}>
          <CardBody className="mt-0">
            <div className="connect-title">
              <div className="integrationChannel mt-2">
                <img src={SMS_Logo} alt="Sms" style={{ width: '2rem' }} />
              </div>
              {!isGuestMessaging ? (
                <Button size="xs" color="outline-grey">
                  <span>Not Available</span>
                </Button>
              ) : (
                <Button size="xs" color="primary" outline onClick={() => setIsAddSMS(true)}>
                  <IntlMessages id="dashboards.connect" />
                </Button>
              )}
            </div>

            <Row>
              <Colxx xxs="12" className="mb-5" style={{ marginTop: '2rem' }}>
                <div className="text-left">
                  <h2>SMS</h2>
                  <span>
                    Automate responses to SMS messages.
                    Manage and reply to conversations from a
                    unified inbox.
                  </span>
                </div>
              </Colxx>
            </Row>
          </CardBody>
        </Card>
      </Colxx>
    </Row>
  );

  const renderConnectedSection = () => (
    <Fragment>
      <Separator className="mb-3" />
      <Row className="m-2 my-3">
        <Colxx xxs="12" className="mb-2">
          <h5 >
            <b>
              <IntlMessages id="guest-messaging.choose-communication-channels" defaultMessage="Choose your communication channels" />
            </b>
          </h5>
        </Colxx>
      </Row>

      <Row className="m-2">
        {isLoading ? (
          <div className="text-center loading" />
        ) : (
          <Fragment>
            {whatsAppIntegrations.map((integration, index) => (
              <Fragment key={`whatsapp-${integration.id || index}`}>
                <WhatsappIntegrationThumb
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                  isSelected={integration.id === selectedWhatsAppIntegrationId}
                  onSelect={() => handleSelectIntegration('WhatsApp', integration.id)}
                  onDelete={() => handleDeleteSelectedIntegration('WhatsApp')}
                />
              </Fragment>
            ))}

            {unifiedEmailIntegrationsList.map((integration, index) => (
              <Fragment key={`email-unified-${integration.id || index}`}>
                <EmailIntegrationThumb
                  integration={integration}
                  propertyId={propertyId}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                  title="Emails in Unified Inbox"
                  isSelected={integration.id === selectedEmailIntegrationId}
                  onSelect={() => handleSelectIntegration('Email', integration.id)}
                  onDelete={() => handleDeleteSelectedIntegration('Email')}
                />
              </Fragment>
            ))}
            {SMSIntegrations.map((integration, index) => (
              <Fragment key={`Sms-${integration.id || index}`}>
                <SMSIntegrationThumb
                  integration={integration}
                  propertyId={propertyId}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                  title="Sms"
                  isSelected={integration.id === selectedSMSIntegrationId}
                  onSelect={() => handleSelectIntegration('Sms', integration.id)}
                  onDelete={() => handleDeleteSelectedIntegration('Sms')}
                />
              </Fragment>
            ))}
          </Fragment>
        )}
      </Row>
    </Fragment>
  );

  return (
    <Fragment>
      {/* Top “Connect” cards – WhatsApp & Emails in Unified Inbox */}
      {renderConnectCards()}
      {/* Connected channels list */}
      {hasAnyIntegration && renderConnectedSection()}
      {/* Modals for creating new integrations */}
      {isAddWhatsApp && (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12" />
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <WhatsappIntegration
                  visible={isAddWhatsApp}
                  toggle={() => {
                    setIsAddWhatsApp(false);
                    LoadIntegrations();
                    loadSelectedChannels();
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12" />
            </Row>
          </Colxx>
        </Row>
      )}

      {isUnifiedEmailIntegration && (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12" />
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <AddEmailIntegration
                  visible={isUnifiedEmailIntegration}
                  channel="EmailAssistant"
                  toggle={() => {
                    setIsUnifiedEmailIntegration(false);
                    LoadIntegrations();
                    loadSelectedChannels();
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12" />
            </Row>
          </Colxx>
        </Row>
      )}

      {isAddSMS && (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12" />
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <SMSIntegration
                  visible={isAddSMS}
                  channel="Sms"
                  toggle={() => {
                    setIsAddSMS(false);
                    LoadIntegrations();
                    loadSelectedChannels();
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12" />
            </Row>
          </Colxx>
        </Row>
      )}
    </Fragment>
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, userName } = settings;
  return {
    propertyId,
    userName,
  };
};

export default injectIntl(connect(mapStateToProps, {})(CommunicationChannels));
